import React from 'react';
import { motion } from "framer-motion";
import { Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Service = ({service}) => {
    const {id, name, price, img, description} = service;

    const navigate = useNavigate();
    const handleNavigateToServiceBooked = id => {
      navigate(`/service/${id}`);
    }
    
    return (
        <Col>
          <Card>
            <Card.Img variant="top" src={img} alt={name} />
            <Card.Body>
              <Card.Title>{name}</Card.Title>
              <Card.Text>{price}</Card.Text>
              <Card.Text style={{textAlign: 'justify'}}>{description}</Card.Text>
              <motion.button whileHover={{ scale: 1.1}} whileTap={{ scale: 0.9 }} className='btn btn-outline-success' onClick={() => handleNavigateToServiceBooked(id)}>Checkout</motion.button>
            </Card.Body>
          </Card>
        </Col>
    );
};

export default Service;